import moment from "moment";

/**
 * @description appends on expanded property to each object in the array for use in the table component
 * @param items object[]
 * @returns [{...item, expaned: false}]
 */
export const ConvertRowData = (items: any, isDocket: boolean = false) => {
  let rows: any = [];
  items.forEach((element: any) => {
    let elementCopy = { ...element };

    for (let key of Object.keys(elementCopy)) {
      if (typeof elementCopy[key] == "string" && isDate(elementCopy[key])) {
        elementCopy = isDocket
        ? { ...elementCopy, [key]: formatDateMMDDYY(elementCopy[key]) }
        : { ...elementCopy, [key]: new Date(elementCopy[key]).toDateString() };
      }

      if (Array.isArray(elementCopy[key]) && elementCopy[key].length > 0 && isDate(elementCopy[key][0])) {
          let newDates = [];
          for (let date of elementCopy[key]) {
            newDates.push(isDocket
              ? formatDateMMDDYY(date)
              : new Date(date).toDateString())
          }

          elementCopy = { ...elementCopy, [key]: newDates };
        }
    }

    rows.push({ ...elementCopy, expanded: false });
  });
  return rows;
};

const isDate = (dateCandidate: string) => {
  return moment(dateCandidate, 'YYYY-MM-DDTHH:mm:ss.SSS', true).isValid() ||
    moment(dateCandidate, 'YYYY-MM-DDTHH:mm:ss.SSSS', true).isValid() ||
    moment(dateCandidate, 'YYYY-MM-DDTHH:mm:ss.SSSZ', true).isValid() ||
    moment(dateCandidate, 'YYYY-MM-DDTHH:mm:ss.SSZ', true).isValid();
}

const formatDateMMDDYY = (date: string) => {
  var formattedDate = moment(date, 'YYYY-MM-DD');
  return formattedDate.format('MM-DD-YY');
}

/**
 *
 * @param data any{} - accepts in an object
 * @returns rowDef[] - returns an array of kendo row definition objects
 * @example
 * // return value
 * [{
 *  field: string,
 *  title: string
 *  filter: string
 * }]
 *
 * filter = "text" | "numeric"
 */
export const GenerateColumnDefinition = async (data: any) => {
  let rowDef: any = [];
  if (data) {
    let keys = Object.keys(data);
    keys.forEach((item: string) => {
      let value = data[item.toString()];
      let type = typeof value;
      let filter: string;
      let isHidden: boolean = false;
      switch (type) {
        case 'string':
          filter = 'text';
          break;
        case 'number':
          filter = 'numeric';
          break;
        default:
          filter = 'text';
          break;
      }
      rowDef.push({
        field: item,
        title: item.replace(/([A-Z])/g, ' $1').toUpperCase(),
        filter: filter,
        hidden: isHidden,
      });
    });
  }
  return rowDef;
};

export const GenerateDraftColumnDefinition = async (data: any) => {
  let rowDef: any = [];
  if (data) {
    let keys = Object.keys(data);
    keys.forEach((item: string) => {
      let value = data[item.toString()];
      let type = typeof value;
      let filter: string;
      let isHidden: boolean;

      switch (type) {
        case 'string':
          filter = 'text';
          break;
        case 'number':
          filter = 'numeric';
          break;
        default:
          filter = 'text';
          break;
      }

      switch (item) {
        case 'id':
          isHidden = true;
          break;
        case 'agencyId':
          isHidden = true;
          break;
        case 'titleId':
          isHidden = true;
          break;
        case 'chapterId':
          isHidden = true;
          break;
        case 'modifiedBy':
          isHidden = true;
          break;
        case 'modifiedOn':
          isHidden = true;
          break;
        case 'draftId':
          isHidden = true;
          break;
        default:
          isHidden = false;
          break;
      }

      rowDef.push({
        field: item,
        title: item.replace(/([A-Z])/g, ' $1').toUpperCase(),
        filter: filter,
        hidden: isHidden,
      });

    });
  }

  return rowDef;
};

export const GenerateDocketColumnDefinition = async (data: any) => {
  let rowDef: any = [];

  if (data) {
    let keys = Object.keys(data);
    keys.forEach((item: string) => {
      let value = data[item.toString()];
      let type = typeof value;
      let filter: string;
      let isHidden: boolean = true;
      let title: string = '';
      let colWidth = 0;

      switch (type) {
        case 'string':
          filter = 'text';
          break;
        case 'number':
          filter = 'numeric';
          break;
        default:
          filter = 'text';
          break;
      }

      switch (item) {
        case 'titleNumber':
          title = 'TITLE';
          isHidden = false;
          colWidth = 55;
        break;
        case 'chapterNumber':
          title = 'CHAPTER(S)';
          isHidden = false;
          colWidth = 105;
        break;
        case 'description':
          title = 'DESCRIPTION';
          isHidden = false;
          colWidth = 145;
        break;
        case 'hearingNoticeReceivedDates':
          title = 'NOTICE RECEIVED';
          isHidden = false;
          colWidth = 145;
        break;
        case 'scheduleHearingDates':
          title = 'HEARING DATE';
          isHidden = false;
          colWidth = 145;
        break;
        case 'agReceivedDate':
          title = 'AG RECEIVED';
          isHidden = false;
          colWidth = 115;
        break;
        case 'agDecisionDate':
          title = 'AG DECISION';
          isHidden = false;
          colWidth = 115;
        break;
        case 'gproReceivedDate':
          title = 'GOV RECEIVED';
          isHidden = false;
          colWidth = 135;
        break;
        case 'gproDecisionDate':
          title = 'GOV DECISION';
          isHidden = false;
          colWidth = 135;
        break;
        case 'sosFiledDate':
          title = 'SOS FILED';
          isHidden = false;
          colWidth = 90;
        break;
        case 'effectiveDate':
          title = 'EFFECTIVE DATE';
          isHidden = false;
          colWidth = 135;
        break;
      }

      rowDef.push({
        field: item,
        title: title,
        filter: filter,
        hidden: isHidden,
        width: colWidth
      });
    });
  }

  return rowDef;
};

export const GenerateFilingColumnDefinition = async (data: any) => {
  let rowDef: any = [];
  if (data) {
    let keys = Object.keys(data);
    keys.forEach((item: string) => {
      let value = data[item.toString()];
      let type = typeof value;
      let filter: string;
      let isHidden: boolean;
      switch (type) {
        case 'string':
          if (item.toString().includes('On')) {
            filter = 'date';
          } else {
            filter = 'text';
          }
          break;
        case 'number':
          filter = 'numeric';
          break;
        default:
          filter = 'text';
          break;
      }
      switch (item) {
        case 'actionDate':
        case 'agencyId':
        case 'chapterId':
        case 'docketNumberId':
        case 'docketNumberDto':
        case 'draftId':
        case 'effectiveOn':
        case 'expiresOn':
        case 'filingActionId':
        case 'filingDetail':
        case 'filingFormId':
        case 'id':
        case 'publicationDate':
        case 'titleId':
          isHidden = true;
          break;
        default:
          isHidden = false;
          break;
      }
      rowDef.push({
        field: item,
        title: item.replace(/([A-Z])/g, ' $1').toUpperCase(),
        filter: filter,
        hidden: isHidden,
      });
    });
  }
  return rowDef;
};

export const GenerateRolesColumnDefinition = async () => {
  let rowDef: any = [];

  rowDef.push({
    field: 'id',
    title: 'id',
    filter: 'text',
    hidden: true,
  });
  rowDef.push({
    field: 'roleName',
    title: 'Role Name',
    filter: 'text',
    hidden: false,
  });
  rowDef.push({
    field: 'action',
    title: 'Action',
    filter: 'button',
    hidden: false,
  });

  return rowDef;
};

export const GenerateUserSubscriptionColumnDefinition = () => {
  let rowDef: any = [];

  rowDef.push({field: "agencyRow", title: "AGENCY", filter: "text", hidden: false,});
  rowDef.push({field: "titleRow", title: "TITLE", filter: "text", hidden: false,});
  rowDef.push({field: "chapterRow", title: "CHAPTER", filter: "text", hidden: false,});
  rowDef.push({field: "button", hidden: false});

  return rowDef;
};

export const GenerateSubUserManagementColumns = () => {
  let rowDef: any = [];

  rowDef.push({field: "emailAddress", title: "EMAIL ADDRESS", filter: "text", hidden: false,});
  rowDef.push({field: "button", hidden: false});

  return rowDef;
};

export const GenerateAppUserColumnDefinition = async (data: any) => {
  let rowDef: any = [];

  let keys = Object.keys(data);

  keys.forEach((item: string) => {
    let value = data[item.toString()];
    let type = typeof value;
    let filter: string;
    let isHidden: boolean;
    switch (type) {
      case 'string':
        filter = 'text';
        break;
      case 'number':
        filter = 'numeric';
        break;
      default:
        filter = 'text';
        break;
    }
    switch (item) {
      case 'id':
        isHidden = true;
        break;
      case 'nebraskaUserId':
        isHidden = true;
        break;
      case 'givenName':
        isHidden = true;
        break;
      case 'surname':
        isHidden = true;
        break;
      case 'email':
        isHidden = true;
        break;
      case 'isActive':
        isHidden = false;
        break;
      case 'avatarContainer':
        isHidden = true;
        break;
      case 'avatarBlob':
        isHidden = true;
        break;
      case 'bearerToken':
        isHidden = true;
        break;
      case 'lastLoginOn':
        isHidden = true;
        break;
      default:
        isHidden = false;
        break;
    }
    rowDef.push({
      field: item,
      title: item.replace(/([A-Z])/g, ' $1').toUpperCase(),
      filter: filter,
      hidden: isHidden,
    });
  });

  return rowDef;
};
